<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>


<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="table-container">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue" (input)="applyFilter2($event)">
      </div>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.dataGridAdmin"
      (click)="openReorder()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
        <path style="fill:'#FFFFFF'"
          d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
      </svg>
      <span class="reload_text text-white">Settings</span>
    </div>
    <div class="">
      <div class="d-flex gap-2 action-buttons-container">
        <div *ngIf="data.saveButtonForTemplate"
          class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openAddPopup()"
          matTooltip="Add Template Section">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <table class="dynamic-table-container documentTable">
    <th style="min-width: 60px; text-align: center;"
      [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
      <div style="display: flex;">
        <div>
          <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
        </div>
      </div>
    </th>
    <th id="grid-header-container"
      *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
      [ngStyle]="{'min-width': taskDocumentsDataForGridData.width, 'max-width': taskDocumentsDataForGridData.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
      class="sticky-dynamic-col1">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>{{taskDocumentsDataForGridData.fieldColumnarray}}</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
        <!-- <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                        (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
                </div> -->
      </div>
    </th>
    <th id="menu" class="sticky-col first-col"></th>
    <!-- search input row is added -->
    <tr>
      <td [class]="
                makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''
              "></td>
      <td *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
        [ngStyle]="{'min-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200,'max-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200}"
        class="sticky-dynamic-col1">
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
        </div>
      </td>
    </tr>
    <!-- data row -->
    <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
      [class.highlightRow]="list.childCheckBoxs == true">
      <td style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, list, idx)">
          </div>
        </div>
      </td>
      <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
        class="sticky-dynamic-row1"
        [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">

        <span *ngIf="key.dataType=='CHECKBOX'">
          <div class="gridCheckBoxes">
            <!-- <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" alt="Yes"
                            width="20" height="20">
                        <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" alt="No"
                            width="20" height="20"> -->
            <img *ngIf="list[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg" width="16"
              height="16" alt="access" />
            <img *ngIf="list[key.columnsListarray] == false" src="../../../assets/img/cr_module/noAcessSymbol.svg"
              width="16" height="16" alt="no access" />
          </div>
        </span>
        <span
          *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
          list[key.columnsListarray] }}</span>

        <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(list,key.columnsListarray)">
              <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
              <span class="ms-1">View</span>
            </button>
          </div>
        </span>


        <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
      </td>
      <td class="sticky-col first-col">
        <div class="action-icons">
          <i *ngIf="data.saveButtonForTemplate" class="fa-solid fa-pencil" matTooltip="Edit Form Template"
            style="margin-left: 5px;" (click)="openEditPopup(list, true)"></i>
          <i *ngIf="data.saveButtonForTemplate" class="fa-sharp fa-solid fa-trash" matTooltip="Delete Form Template"
            style="margin-left: 5px;" (click)="openDeletePopup(list)"></i>
          <i class="fa-solid fa-edit" matTooltip="Form Template Fields" style="margin-left: 5px;"
            (click)="openFormTemplateFields(list)"></i>
          <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
            src="../../assets/img/trail-individual.svg" (click)="openAuditTrail('individual',list)" />
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>

</div>
<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>

    <div style="padding: 10px;">
      <div class="row">
        <div class="col-md-6">
          <!-- Section Name -->
          <div><label for="email ">{{dynamicLabel['SECTION_NAME']}}</label><span class="mandatory-symbol">*</span></div>
          <input id="sectionName" class="input-filed-continers" type="text"
            [(ngModel)]="formSectionTemplateData.sectionName" (focusout)="onFieldFocusout()">
          <span id="sectionName-required-msg">Please enter an section name</span>
        </div>
        <div class="col-md-6">
          <!-- Fields Per Line -->
          <div><label for="email">{{dynamicLabel['FIELDS_PER_LINE']}}</label></div>
          <mat-select matInput placeholder="Select" id="copyTemplate"
            [(ngModel)]="formSectionTemplateData.fieldsPerLine" (closed)="fieldsPerLinesearchTxt=''"
            (click)="focusmethod('fieldsPerLineSearch')">
            <input type="search" id="fieldsPerLineSearch" class="dropdownsearchstyle"
              [(ngModel)]="fieldsPerLinesearchTxt" matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of fieldsPerLineDropdown | assessmentSearch :fieldsPerLinesearchTxt"
              [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <!-- Add Record Label -->
          <div><label for="email">{{dynamicLabel['ADD_RECORD_LABEL']}}</label><span class="mandatory-symbol">*</span></div>
          <input id="addRecordLabel" class="input-filed-continers" type="text"
            [(ngModel)]="formSectionTemplateData.addRecordLabel">
            <span id="recordlabel-required-msg">Please enter an section name</span>
        </div>
        <div class="col-md-3">
          <!-- Verification Reqd? -->
          <div><label for="email">{{dynamicLabel['VERIFICATION_REQD']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="formSectionTemplateData.verificationReqd1">
            <span class="active-inActive-container" *ngIf="formSectionTemplateData.verificationReqd1==true"
              [ngStyle]="formSectionTemplateData.verificationReqd1 == true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="formSectionTemplateData.verificationReqd1==false"
              [ngStyle]="formSectionTemplateData.verificationReqd1 == false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>

        <div class="col-md-3" *ngIf="formSectionTemplateData.verificationReqd1==true">
          <!-- Verification Reqd? -->
          <div><label for="email">{{dynamicLabel['WITHDRAWAL_REQD']}}</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="formSectionTemplateData.withdrawalReqd1">
            <span class="active-withdrawal-container" *ngIf="formSectionTemplateData.withdrawalReqd1==true"
              [ngStyle]="formSectionTemplateData.withdrawalReqd1 == true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="formSectionTemplateData.withdrawalReqd1==false"
              [ngStyle]="formSectionTemplateData.withdrawalReqd1 == false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row" *ngIf="!visibleEditButton">
        <div class="col-md-6">
          <div><label for="email">Copy Template From</label></div>
          <mat-select matInput placeholder="Select" id="copyTemplate"
            [(ngModel)]="formSectionTemplateData.copyFromTemplateId" (closed)="templatesearchTxt=''"
            (click)="focusmethod('templateSearch')">
            <input type="search" id="templateSearch" class="dropdownsearchstyle" [(ngModel)]="templatesearchTxt"
              matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of templateDropdown | assessmentSearch :templatesearchTxt"
              [value]="item.templateId" (onSelectionChange)="onFormTemplateSelect($event,item)">
              {{ item.templateName }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6" *ngIf="formSectionTemplateData.copyFromTemplateId != null">
          <div><label for="email">Copy Section From</label><span
              *ngIf="formSectionTemplateData.copyFromTemplateId != null" class="mandatory-symbol">*</span></div>
          <mat-select matInput placeholder="Select" id="copySectionForm"
            [(ngModel)]="formSectionTemplateData.copyFromTemplateSectionId" (closed)="sectionSearchTxt=''"
            (click)="focusmethod('sectionSearch')">
            <input type="search" id="sectionSearch" class="dropdownsearchstyle" [(ngModel)]="sectionSearchTxt" matInput
              placeholder="Search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of sectionDropdown | assessmentSearch :sectionSearchTxt"
              [value]="item.sectionId">
              {{ item.sectionName }}
            </mat-option>
          </mat-select>
          <span id="copySectionForm-required-msg">Please select section to copy</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <!-- Header -->
          <div><label for="email">{{dynamicLabel['HEADER']}}</label></div>
          <textarea class="textarea-filed-continers" type="text"
            [(ngModel)]="formSectionTemplateData.header"></textarea>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-12">
          <!-- Instructions -->
          <div><label for="email">{{dynamicLabel['INSTRUCTIONS']}}</label></div>
          <textarea class="textarea-filed-continers" type="text"
            [(ngModel)]="formSectionTemplateData.instructions"></textarea>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12" *ngIf="visibleEditButton">
          <div><label for="email">{{dynamicLabel['UPDATE_REASON']}} <span class="mandatory-symbol">*</span></label>
          </div>
          <textarea id="udpateReq" class="textarea-filed-continers" type="text"
            [(ngModel)]="formSectionTemplateData.updateReason"></textarea>
          <span id="update-reason-required-msg">Please enter update reason</span>
        </div>
      </div>
    </div>
  </div>
  <br>

  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(formSectionTemplateData)" *ngIf="!visibleEditButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(formSectionTemplateData)" *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Reason For Delete</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="formSectionTemplateData.deleteReason" (focusout)="onFieldFocusout()"></textarea>
          <span id="deleteTextarea-required-msg">Please provide the reason for delete</span>
        </div>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>


<ng-template #deleteConfirmationPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Delete Confirmation</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12 text-center">
          <b>
            There are {{fieldsCount}} field(s) added to this section. If the section is deleted, the fields will also be
            removed.
          </b>
          <div><b>Are you sure you want to proceed with deletion?</b></div>
        </div>

      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="proceedDelete(deleteList)">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteConfirmation()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #fieldPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelFieldPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">Form Section Fields</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="row">
      <app-form-template-fields [data]="formSectionTemplateData"></app-form-template-fields>
    </div>
  </div>
</ng-template>

<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>